import { NotFoundContainer } from '../../containers/404'
import { PageContainer } from '../../components/layout'
import { Routes } from '@dtx-company/true-common/src/constants/routes'
import type { NextPage } from 'next'

const NotFound: NextPage = () => {
  return (
    <PageContainer disableNotifications disableSideNav page={Routes.NOT_FOUND}>
      <NotFoundContainer />
    </PageContainer>
  )
}

export default NotFound
